<template>
    <div class="row-in-form">
        <label v-if="type !== 'hidden'" :for="inputId">{{ label }} <span v-if="inputVar.required">*</span></label>

        <!-- Input select -->
        <div v-if="type === 'select'">
            <vue-select :id="inputId" v-model="inputVar.value" :options="options" :select-on-tab="true" :placeholder="getPlaceholder()" :readonly="!!readonly" :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }" :disabled="!!disabled"><span slot="no-options">Nenhum resultado.</span></vue-select>
        </div>

        <!-- Input File -->
        <div v-else-if="type === 'file'">
            <div :id="inputId" class="wrapper-file" style="cursor: pointer;">
                <div class="file-container">
                    <label :for="inputId + '-files'"><i class="fa fa-upload"></i><u v-if="!inputVar.value" class="align-center file-name">{{getPlaceholder()}}</u><div class="file-name" ref="nameFile"></div><a class="fa fa-times" v-on:click.prevent="clearFile" href="#" ref="removeFile" /></label>
                </div>
                <input :id="inputId + '-files'"
                        :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }" :disabled="!!disabled" type="file" @change="selectFile()" ref="myfiles" />
            </div>
        </div>
        

        <!-- Input File -->
        <div v-else-if="type === 'file'">
            <div :id="inputId" class="wrapper-file">
                <div class="file-container">
                    <label :for="inputId + '-files'">
                        <i class="fa fa-upload"></i>
                        <div class="file-name" ref="nameFile"></div>
                        <a class="fa fa-times" v-on:click.prevent="clearFile" href="#" ref="removeFile" />
                    </label>
                </div>
                <input :id="inputId + '-files'"
                        :placeholder="getPlaceholder()"
                        :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                        :disabled="!!disabled"
                        type="file"
                        @change="selectFile()"
                        ref="myfiles" />
            </div>
        </div>
        <span v-if="!inputVar.validation.status && (form.attemptSubmit || (form.cnpjInvalid && validationType == 'cnpj'))"
                class="invalid-feedback">{{ inputVar.validation.message }}</span>
    </div>
</template>

<script>
    export default {
        name: 'FormHelperBlob',
        props: [
            'step',
            'readonly',
            'inputVar',
            'placeholder',
            'form',
            'label',
            'mask',
            'type',
            'disabled',
            'icon',
            'validationType',
            'options',
            'compareTo',
            'id',
            'fileTypes',
            'rows',
            'lostFocus',
            'maxlength',
            'max',
            'min',
            'linkInLabel'
        ],
        data() {
            return {
                moneyConfig: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2,
                    masked: false
                }
            }
        },
        computed: {
            inputId: function () {
                // Caso tenha um ID, ele retorna. Caso não tenha, ele gera um id baseado na label
                return this.id ? this.id : this.convertLabelToId(this.label)
            }
        },
        mounted() {
            this.validateInput(this.inputVar.value)
        },
        watch: {
            'inputVar.value': function (val) {
                if (this.type == 'file' && (val === '' || val === null)) {
                    this.removeNameFile()
                }
                this.validateInput(val)
            },
            'compareTo.value': function () {
                this.validateInput(this.inputVar.value)
            }
        },
        methods: {
            formataNumero: function (value, decimals = 2) {
                if (!value && value !== 0) {
                    return "";
                }
                let val = (value / 1).toFixed(decimals).replace(".", ",");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
            convertLabelToId: function (text) {
                // Remove acentos e espaços do label para usar como ID
                text = text.toLowerCase()
                text = text.replace(/ /g, '-')
                text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
                text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
                text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
                text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
                text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
                text = text.replace(new RegExp('[Ç]', 'gi'), 'c')

                return text
            },
            getPlaceholder: function () {
                if (this.placeholder !== undefined)
                    // Retorna placeholder caso ele esteja definido
                    return this.placeholder
                // Cria um placeholder com base na label
                else return this.inputVar.required ? this.label + ' *' : this.label
            },
            getMaxLength: function () {
                if (this.maxlength !== undefined)
                    return this.maxlength
                else
                    return "1000000"
            },
            getBlurEvent: function () {
                // // console.log(this.lostFocus);
                if (this.lostFocus !== undefined)
                    return this.lostFocus();
                else return this.blurFake;
            },
            blurFake: function () { },

            getTextAreaRows: function () {
                if (this.rows !== undefined) {
                    return this.rows
                } else {
                    return '5'
                }
            },
            validateInput: function (val) {
                // Verifica se o campo é obrigatório
                if (this.inputVar.required) {
                    // Verifica se não está preenchido
                    if (val === '' || val === null || val === undefined || val.length == 0) {
                        this.inputVar.validation = this.buildError(
                            'Por favor, preencha o campo acima'
                        )
                    }
                    else this.validate(val)
                } else {
                    // Valida apenas se tiver um valor
                    if (val) this.validate(val)
                    else this.inputVar.validation.status = true
                }
            },
            validate: function (val) {
                // Regex para validação
                let re;

                if (this.validationType) {
                    switch (this.validationType) {                        
                        case 'quotes':
                            if (val.match(/['",]+/g))
                                this.inputVar.validation = this.buildError('Campos de texto não podem conter aspas e vírgulas');
                            else
                                this.inputVar.validation.status = true;
                            break;
                    }
                } else {
                    this.inputVar.validation.status = true
                }
            },
            buildError: function (msg) {
                // Escreve o erro no formato padrão e retorna
                return { status: false, message: msg }
            },
            clearString: function (str) {
                // Remove characteres especiais da string
                return str.replace(/[^\d]/g, '')
            },
            selectFile: function () {
                if (this.$refs.myfiles.files.length > 0) {
                    const self = this
                    const file = this.$refs.myfiles.files[0]
                    const reader = new FileReader()
                    let base64 = ''
                    reader.readAsDataURL(file)

                    reader.onloadend = function () {
                        self.$set(self.inputVar, 'value', file)
                        self.$set(self.inputVar, 'name', file.name)
                        self.$set(self.inputVar, 'tipo', file.type.split('/')[1])
                        self.$set(self.inputVar, 'size', file.size)
                    }
                    if (this.fileTypes) {
                        if (!this.fileTypes.includes(file.name.split('.').pop())) {
                            alert(
                                'Utilizar somente arquivos dos tipos: ' + this.fileTypes.join(',')
                            )
                            return
                        }
                    }
                    this.$refs.nameFile.innerHTML = file.name
                    this.$refs.removeFile.style.display = 'block'
                }
            },
            clearFile: function () {
                this.$set(this.inputVar, 'name', '')
                this.$set(this.inputVar, 'value', '')
            },
            removeNameFile: function () {
                this.$refs.nameFile.innerHTML = ''
                this.$refs.removeFile.style.display = 'none'
                this.$refs.myfiles.value = '';
            },
            replaceAll: function (string, token, newtoken) {
                while (string.indexOf(token) != -1)
                    string = string.replace(token, newtoken);
                return string;
            }
        }
    }
</script>